function initialState() {
    return {
        all: [],
        payment_types: {},
        loading: false,
        pack: null,
        payment_type: 1,
        discount_code: null,
        discount: null,
        estimated_price_with_vat: '-',
        estimated_price_without_vat: '-',
        code_valid: false,
        code_error: '',
        displayed_prices: {},
    }
}

const getters = {
    all:                                state => state.all,
    loading:                            state => state.loading,
    pack:                               state => state.pack,
    payment_type:                       state => state.payment_type,
    payment_types:                      state => state.payment_types,
    discount_code:                      state => state.discount_code,
    code_valid:                         state => state.code_valid,
    code_error:                         state => state.code_error,
    estimated_price_with_vat:           state => state.estimated_price_with_vat,
    estimated_price_without_vat:        state => state.estimated_price_without_vat,
    displayed_prices:                   state => state.displayed_prices,
}

const actions = {
    fetchDataMinimal({ commit, state }) {
        axios.get('/api/front/packs').then(response => {
            commit('setAll', response.data.packs);
        }).catch(error => {
            let message = error.response.data.message || error.message
            console.error(message);
        });
    },
    fetchData({ commit, state }) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios.get('client/packs').then(response => {
                commit('setAll', response.data.packs);
                if (state.pack === null && typeof response.data.packs[0] !== 'undefined') {
                    // commit('setPack', response.data.packs[0]);
                }
                commit('setPaymentTypes', response.data.payment_types);
                resolve();
            }).catch(error => {
                let message = error.response.data.message || error.message
                console.log(message);
                reject();
            }).finally(() => {
                commit('setLoading', false);
            });
        });
    },
    fetchPrice({ commit, state }) {
        commit('setLoading', true);
        return new Promise((resolve, reject)=> {
            let params = new FormData();
            params.set('discount_code', state.discount_code ?? '');
            params.set('pack_id', state.pack.id);
            axios.post('client/packs/price', params).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            }).finally(() => {
                commit('setLoading', false);
            });
        });
    },
    prepareOrderWithIntent({ commit, state }) {
        return new Promise((resolve, reject) => {
            axios.post('client/order/stripe/prepare', {
                discount_code: state.discount_code,
                payment_method_id: state.payment_type,
                pack_id: state.pack.id,
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    checkCompletion({ commit, state, dispatch }, payment_intent) {
        return new Promise((resolve, reject) => {
            resolve(false);
            /*axios.post('client/order/stripe/check', {
                stripe_payment_intent: payment_intent
            }).then((response) => {
                if (1 === Number(response.data.payment_complete)) {
                    resolve(true);
                    dispatch('NavbarIndex/fetchData', {}, {root:true})
                } else {
                    resolve(false);
                }
            }).catch((error) => {
                reject(error);
            });*/
        });
    },
    setDiscount({ commit }, data) {
        commit('setDiscount', data);
    },
    setPack({ commit }, data) {
        commit('setPack', data);
    },
    setEstimatedPriceWithVat({ commit }, data) {
        commit('setEstimatedPriceWithVat', data);
    },
    setEstimatedPriceWithoutVat({ commit }, data) {
        commit('setEstimatedPriceWithoutVat', data);
    },
    setDiscountCode({ commit }, data) {
        commit('setDiscountCode', data);
    },
    setPaymentType({ commit }, data) {
        commit('setPaymentType', data);
    },
    setDisplayedPrices({ commit }, data) {
        commit('setDisplayedPrices', data);
    },
    setCodeValid({ commit }, data) {
        commit('setCodeValid', data);
    },
    setCodeError({ commit }, data) {
        commit('setCodeError', data);
    },
    resetState({ commit }) {
        commit('resetState')
    },
}

const mutations = {
    setAll(state,items) {
        state.all = items;
    },
    setDisplayedPrices(state, data) {
        state.displayed_prices = data;
    },
    setPaymentTypes(state,items) {
        state.payment_types = items;
    },
    setDiscountCode(state, data) {
        state.discount_code = data;
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setDiscount(state, data) {
        state.discount = data;
    },
    setEstimatedPriceWithVat(state, data) {
        state.estimated_price_with_vat = data;
    },
    setEstimatedPriceWithoutVat(state, data) {
        state.estimated_price_without_vat = data;
    },
    setPack(state, data) {
        state.pack = data;
    },
    setPaymentType(state, data) {
        state.payment_type = data;
    },
    setCodeValid(state, data) {
        state.code_valid = data;
    },
    setCodeError(state, data) {
        state.code_error = data;
    },
    resetSate(state) {
        state = Object.assign(state, initialState())
    },
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}

